import { render, staticRenderFns } from "./ShareOfShelfPanel.vue?vue&type=template&id=cd337cb2&scoped=true"
import script from "./ShareOfShelfPanel.vue?vue&type=script&lang=js"
export * from "./ShareOfShelfPanel.vue?vue&type=script&lang=js"
import style0 from "./ShareOfShelfPanel.vue?vue&type=style&index=0&id=cd337cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd337cb2",
  null
  
)

export default component.exports